export default {
  title: 'VOD Orange : films cinéma et séries en streaming et téléchargement',
  description: 'Films cinéma et séries en VOD, disponibles à la location 48h ou à l’achat pour les regarder à volonté en streaming ou téléchargement, sur tous vos écrans.'
}
